export function calcDailyCalories(profile, weight) {
  if (!profile.heightCm || !weight || !profile.birthYear) return null;

  const age = new Date().getFullYear() - profile.birthYear;

  let bmr =
    10 * weight +
    6.25 * profile.heightCm -
    5 * age +
    (profile.sex === "female" ? -161 : 5);

  const jobFactor = {
    office: 1.2,
    light: 1.35,
    medium: 1.55,
    heavy: 1.75
  }[profile.jobType || "office"];

  let tdee = bmr * jobFactor;

  const weeklyBurn =
    (profile.weeklyLightMin || 0) * 4 +
    (profile.weeklyHeavyMin || 0) * 8;

  const dailyBurn = weeklyBurn / 7;

  return Math.round(tdee + dailyBurn);
}